import { Dispatch, RefObject, SetStateAction, useCallback, useState } from 'react';

import { faCompress, faExpand } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import MediaMethods from '../mediaDataCollector/MediaMethods';

interface MediaFullScreenProps {
  videoContainerId: string;
  playerRef: RefObject<HTMLAudioElement> | RefObject<HTMLVideoElement> | RefObject<any>;
  setShowControlBar: Dispatch<SetStateAction<boolean>>;
}

function FullScreenButton({ videoContainerId, playerRef, setShowControlBar }: MediaFullScreenProps) {
  const [isFullScreen, setIsFullScreen] = useState<boolean>(false);
  const video = document.getElementById(videoContainerId);

  function fullScreen() {
    MediaMethods.fullScreen(video, playerRef);

    setIsFullScreen(!isFullScreen);
    setShowControlBar(!isFullScreen);

    document.addEventListener('webkitfullscreenchange', escapeKeyHandler, false);
    document.addEventListener('mozfullscreenchange', escapeKeyHandler, false);
    document.addEventListener('fullscreenchange', escapeKeyHandler, false);
    document.addEventListener('MSFullscreenChange', escapeKeyHandler, false);
  }

  function exitFullScreen() {
    MediaMethods.exitFullScreen(playerRef);

    setIsFullScreen(!isFullScreen);
    setShowControlBar(!isFullScreen);

    document.removeEventListener('webkitfullscreenchange', escapeKeyHandler, false);
    document.removeEventListener('mozfullscreenchange', escapeKeyHandler, false);
    document.removeEventListener('fullscreenchange', escapeKeyHandler, false);
    document.removeEventListener('MSFullscreenChange', escapeKeyHandler, false);
  }

  function toggleFullsCreen() {
    if (isFullScreen) exitFullScreen();
    else fullScreen();
  }

  const escapeKeyHandler = useCallback(() => {
    if (
      //@ts-ignore
      !document.webkitIsFullScreen &&
      //@ts-ignore
      !document.mozFullScreen &&
      //@ts-ignore
      !document.msFullscreenElement
    ) {
      MediaMethods.escapeKeyHandler(playerRef);

      setIsFullScreen((isFullScreen: boolean) => !isFullScreen);
      setShowControlBar((isFullScreen: boolean) => !isFullScreen);
    }
  }, [playerRef, setShowControlBar]);

  return (
    <div>
      <button className="media-player-button media-player-skip" onClick={toggleFullsCreen} type="button">
        <FontAwesomeIcon className="media-player-icon" icon={isFullScreen ? faCompress : faExpand} />
      </button>
    </div>
  );
}

export default FullScreenButton;
